import {Space} from "antd";
import {StyledPageHeader} from "../../../../../../styles/dashboard/calls/calls";
import {PayoutHistoryTable} from "./table";

export function PayoutHistory() {
  return (
    <div>
      <Space size={24} style={{display: "flex"}} direction="vertical">
        <StyledPageHeader>Payout history</StyledPageHeader>
        <PayoutHistoryTable />
      </Space>
    </div>
  );
}
